// Join / Watch / View on a friends-watching notice (D-120), shared by the bell list and the pop-up.
import { useState, type ReactElement } from "react";
import { errorSentence } from "../lib/api";
import { clock, noticeActions, offerUntil, useTicking } from "../lib/noticeActions";
import type { NotificationItem } from "../lib/types";

type Item = Pick<NotificationItem, "kind" | "href" | "at">;
/** Join / Watch / View on a friends-watching notice (D-120), with the seat offer's countdown; a refusal says why. */
export function WatchNoticeActions({ item, onGo, className = "notif-row__acts" }: { item: Item; onGo: (to: string) => void; className?: string }): ReactElement | null {
  const until = offerUntil(item);
  const now = useTicking(until);
  const [busy, setBusy] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const actions = noticeActions(item, now);
  if (actions.length === 0) return until !== null ? <span className="notif-row__acts"><span className="notif-row__ended">Offer ended</span></span> : null;
  const run = async (label: string, fn: () => Promise<string>) => {
    setBusy(label); setError(null);
    try { onGo(await fn()); } catch (e) { setError(errorSentence(e)); } finally { setBusy(null); }
  };
  return (
    <span className={className}>
      {until !== null && <span className="notif-row__left" aria-label={`${clock(until - now)} left to join`} data-testid="offer-countdown">{clock(until - now)}</span>}
      {actions.map((a) => <button key={a.label} type="button" className="notif-row__action" onClick={() => void run(a.label, a.run)} aria-busy={busy === a.label || undefined} data-testid={a.testId}>{busy === a.label ? "One moment…" : a.label}</button>)}
      {error && <span className="small notif-row__error" role="alert">{error}</span>}
    </span>
  );
}

